import React from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';

class Table extends React.Component {
    render() {

        const tableOptions = {
            loading: true,
            showPagination: true,
            showPageSizeOptions: true,
            showPageJump: true,
            collapseOnSortingChange: true,
            collapseOnPageChange: true,
            collapseOnDataChange: true,
            freezeWhenExpanded: false,
            filterable: true,
            sortable: true,
            resizable: true,
            defaultPageSize: 10,
            // Text
            previousText: 'Předchozí strana',
            nextText: 'Další strana',
            loadingText: 'Načítají se data...',
            noDataText: 'Nenelazena žádná data',
            pageText: 'Strana',
            ofText: 'z',
            rowsText: 'řádků',
        };

        const defautlTable = !this.props.default ? {...tableOptions} : [];

        return (
            <ReactTable
                data={this.props.data}
                columns={this.props.columns}
                defaultFilterMethod={this.props.defaultFilterMethod}
                {...defautlTable}
                {...this.props.tableOptions}
                {...this.props.options}
            />
        );
    }
}

export default Table;



/** WEBPACK FOOTER **
 ** ./src/components/Table/index.js
 **/